import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { candidate, languages } from '../../data/site';
const columns = [{
  heading: 'Campaign',
  links: [{
    label: 'Candidate',
    to: '/candidate'
  }, {
    label: 'Vision',
    to: '/vision'
  }, {
    label: 'Agenda',
    to: '/agenda'
  }, {
    label: 'Track Record',
    to: '/track-record'
  }, {
    label: 'First 100 Days',
    to: '/first-100-days'
  }]
}, {
  heading: 'Participate',
  links: [{
    label: 'Volunteer',
    to: '/join'
  }, {
    label: 'Events',
    to: '/events'
  }, {
    label: 'Support the Campaign',
    to: '/support'
  }, {
    label: 'Campaign Resources',
    to: '/resources'
  }]
}, {
  heading: 'News & Media',
  links: [{
    label: 'Latest News',
    to: '/news'
  }, {
    label: 'Statements',
    to: '/news'
  }, {
    label: 'Speeches',
    to: '/news'
  }, {
    label: 'Media Centre',
    to: '/media'
  }]
}, {
  heading: 'Information',
  links: [{
    label: 'Facts & Answers',
    to: '/facts'
  }, {
    label: 'Manifesto',
    to: '/manifesto'
  }, {
    label: 'Regional Agenda',
    to: '/nigeria'
  }, {
    label: 'Contact',
    to: '/contact'
  }, {
    label: 'FAQs',
    to: '/faq'
  }]
}, {
  heading: 'Legal',
  links: [{
    label: 'Privacy',
    to: '/faq'
  }, {
    label: 'Terms',
    to: '/faq'
  }, {
    label: 'Accessibility',
    to: '/faq'
  }, {
    label: 'Contribution Terms',
    to: '/support'
  }, {
    label: 'Cookie Preferences',
    to: '/faq'
  }]
}];
const socials = [{
  label: 'X',
  Icon: TwitterIcon
}, {
  label: 'Facebook',
  Icon: FacebookIcon
}, {
  label: 'Instagram',
  Icon: InstagramIcon
}, {
  label: 'YouTube',
  Icon: YoutubeIcon
}];
export function Footer() {
  return <footer className="bg-ink text-white" data-id="element-483" data-mp="1in7y37027ukq">
      <div className="mx-auto max-w-content px-4 py-16 sm:px-6 lg:px-10 lg:py-20" data-id="element-484" data-mp="1im6bq6dlflnp">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-6" data-id="element-485" data-mp="1nnn9ht0s6s02">
          <div className="lg:col-span-1" data-id="element-486" data-mp="13l97qiswzq6t">
            <p className="font-display text-2xl" data-id="element-487" data-mp="13k7xggjq37q5">
              {candidate.initials}
              <span className="ml-1.5 font-sans text-sm font-bold tracking-[0.14em] text-gold-400" data-id="element-488" data-mp="zkfjfobk89de">
                {candidate.cycle}
              </span>
            </p>
            <p className="mt-3 max-w-[220px] text-sm leading-relaxed text-white/55" data-id="element-489" data-mp="ptup4d2x5r0a">
              {candidate.slogan}
            </p>
          </div>

          {columns.map(column => <nav key={column.heading} aria-label={column.heading} data-id="element-490" data-mp="fvetpxwuzvkz">
              <h2 className="mb-4 text-xs font-bold uppercase tracking-[0.14em] text-gold-400" data-id="element-491" data-mp="fx9hdjzim1sr">
                {column.heading}
              </h2>
              <ul className="space-y-2.5" data-id="element-492" data-mp="6v8mgtrr7ru9">
                {column.links.map(link => <li key={link.label} data-id="element-493" data-mp="2684acybv6zmw">
                    <Link to={link.to} className="text-[14px] text-white/65 transition-colors duration-150 ease-emphasis hover:text-white" data-id="element-494" data-mp="2672py38yl0si">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="mt-14 border-t border-white/10 pt-8" data-id="element-495" data-mp="2ihk8crevuiu7">
          <p className="max-w-3xl text-[13px] leading-relaxed text-white/45" data-id="element-496" data-mp="2ngx5q63dr8b1">
            Paid for and authorised by the {candidate.name} Presidential Campaign Organisation.
            Not printed at government expense. Contributions are accepted only from eligible
            Nigerian citizens in line with the Electoral Act.
          </p>
          <div className="mt-6 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-497" data-mp="1zq9hubd2k82u">
            <p className="text-[13px] text-white/45" data-id="element-498" data-mp="23tz3aryg69jn">
              © {new Date().getFullYear()} {candidate.name} Campaign Organisation. All rights
              reserved.
            </p>
            <div className="flex items-center gap-4" data-id="element-499" data-mp="3f7bclicz7kd7">
              <div className="flex items-center gap-1" data-id="element-500" data-mp="3f9xkxk7oy3wh">
                {socials.map(({
                label,
                Icon
              }) => <a key={label} href="#" aria-label={label} className="flex h-9 w-9 items-center justify-center rounded-lg text-white/60 transition-colors duration-150 ease-emphasis hover:bg-white/10 hover:text-white" data-id="element-501" data-mp="38ruf548v250p">
                    <Icon aria-hidden className="h-[18px] w-[18px]" data-id="element-502" data-mp="jvsb89md4bt" />
                  </a>)}
              </div>
              <label htmlFor="footer-language" className="sr-only" data-id="element-503" data-mp="3rpx81u4j4m3s">
                Language
              </label>
              <select id="footer-language" defaultValue="English" className="rounded-lg border border-white/20 bg-white/5 px-3 py-2 text-[13px] text-white/80" data-id="element-504" data-mp="a9nno4pjm1hc">
                {languages.map(language => <option key={language} value={language} className="text-ink" data-id="element-505" data-mp="fabhey55owf9">
                    {language}
                  </option>)}
              </select>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}